//@ts-check
import React from 'react';
import { FolderWorkflowAdd } from './FolderWorkflowAdd';
import { FolderWorkflowConfigList } from './FolderWorkflowConfigList';
import { withFolderWorkflowConsumer } from './FolderWorkflowContext';
import { DataFetcher } from '../../_shared/DataFetcher/DataFetcher';
import { ConfirmationModal } from '../..';
import './FolderWorkflow.scss';

const FolderWorkflowManage = ({
    folderWorkflowConfigs,
    workflows,
    filteredTreeData,
    editingConfigId,
    infoModalData,
    pageIndex,
    pageSize,
    totalPages,
    totalCount,
    fetchData,
    addFolderWorkflow,
    updateFolderWorkflow,
    deleteFolderWorkflow,
    onEditStart,
    onEditCancel,
    handleInfoModalClose,
    handlePageIndexChange
}) => {
    return (
        <div className="folder-workflow-container">
            <DataFetcher height={'476px'} onFetchData={fetchData}>
                <div className="folder-workflow-layout">
                    <div className="folder-workflow-layout__top">
                        <h2>Set Workflow for Folder</h2>

                        <FolderWorkflowAdd
                            filteredTreeData={filteredTreeData}
                            workflows={workflows}
                            onAdd={addFolderWorkflow}
                            existingConfigs={folderWorkflowConfigs}
                        />
                    </div>

                    {folderWorkflowConfigs && folderWorkflowConfigs.length > 0 ? (
                        <FolderWorkflowConfigList
                            configs={folderWorkflowConfigs}
                            workflows={workflows}
                            onUpdate={updateFolderWorkflow}
                            onDelete={deleteFolderWorkflow}
                            editingConfigId={editingConfigId}
                            onEditStart={onEditStart}
                            onEditCancel={onEditCancel}
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            totalPages={totalPages}
                            totalCount={totalCount}
                            handlePageIndexChange={handlePageIndexChange}
                        />
                    ) : (
                        <div className="folder-workflow-list-wrapper">
                            <div className="folder-workflow-empty-area">
                                <span>
                                    No folder workflow configurations to show. Please add configurations.
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </DataFetcher>

            {infoModalData.show && (
                <ConfirmationModal
                    show
                    onHide={handleInfoModalClose}
                    onPrimaryClick={handleInfoModalClose}
                    onSecondaryClick={handleInfoModalClose}
                    primaryButtonText="Ok"
                    secondaryButtonText={infoModalData.secondaryButton}
                    title={infoModalData.title}
                    bodyText={infoModalData.body}
                />
            )}
        </div>
    );
};

export default FolderWorkflowManage;
